import slick from 'slick-carousel';

const slideshow = document.querySelectorAll('.slideshow');

const initSlideShow = (id) => {
  const slideshowContent = `#${id} .slideshow-content`;
  const slideNext = `#${id} .slick-next`;
  const slidePrev = `#${id} .slick-prev`;
  const slideTotalWrap = `#${id} .slide-total`;
  const slideCurrentWrap = `#${id} .slide-current`;
  
  
  $(slideshowContent).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 500,
  });
  
  const displayCurrentSlide = () => {
    const slideIndex = $(slideshowContent).slick('slickCurrentSlide');
    const slideCurrent = slideIndex + 1;
  
    $(slideCurrentWrap).html(slideCurrent);
  }
  
  const displayTotalSlides = () => {
    const slidesAll = $(`#${id} .slick-slide`).length;
    const slidesCloned = $(`#${id} .slick-slide.slick-cloned`).length;
    const slidesTotal = slidesAll - slidesCloned;
  
    $(slideTotalWrap).html(slidesTotal);
  }
  
  displayTotalSlides();
  displayCurrentSlide();

  $(slideNext).on('click', () => {
    $(slideshowContent).slick('slickNext');
    displayCurrentSlide();
  });
  
  $(slidePrev).on('click', () => {
    $(slideshowContent).slick('slickPrev');
    displayCurrentSlide();
  });

  $(slideshowContent).on('swipe', () => {
    displayCurrentSlide();
  });
}

slideshow.forEach(slide => {
  const random = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  $(slide).attr('id', random);

  initSlideShow(random);
});